import { useRoutes } from 'react-router-dom'
import '../../src/global.css'
import CssBaseline from '@mui/material/CssBaseline'
import 'react-toastify/dist/ReactToastify.css'
import { MatxTheme } from './components'
// ALL CONTEXTS
import { AuthProvider } from './contexts/JWTAuthContext'
import SettingsProvider from './contexts/SettingsContext'
// ROUTES
import routes from './routes'

import { DataProvider } from './contexts/DataContext'
import { ToastContainer } from 'react-toastify'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'

export default function App() {
  const content = useRoutes(routes)

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <SettingsProvider>
        <AuthProvider>
          <DataProvider>
            <MatxTheme>
              <CssBaseline />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              {content}
            </MatxTheme>
          </DataProvider>
        </AuthProvider>
      </SettingsProvider>
    </LocalizationProvider>
  )
}
